module.exports = __webpack_public_path__ + "static/media/chatIcon.cbadfbb8.svg";